/// <amd-module name="Repos/Views/PullRequest/Components/ActivityFeed/ActivityCards/SourceBranchStateCard" />
import * as React from "react";
import * as Resources from "Repos/Views/PullRequest/Resources";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { Components } from "VSS/Platform/Layout";
import { getIdentity, getIdentityComponent, getPropertyValue } from "../Utils/ActivityFeedUtils";
import { ActivityCardSubtle, IActivityCardSharedProps } from "./ActivityCardSubtle";
import { ActivityShimmer } from "./ActivityShimmer";

export const SourceBranchStateCard: React.FunctionComponent<IActivityCardSharedProps> = props => {
    const { isShim } = props;
    const identityId = getPropertyValue(props.thread, "CodeReviewSourceBranchChangedByIdentity");
    const identity = getIdentity(props.thread, identityId);
    if (!isShim) {
        if (!identity) {
            return null;
        }

        const isDeleted = getPropertyValue(props.thread, "CodeReviewSourceBranchChanged") === "1";

        let format;
        if (isDeleted) {
            format = Resources.ActivityFeedSourceBranchDeleted;
        } else {
            format = Resources.ActivityFeedSourceBranchRestored;
        }

        return (
            <ActivityCardSubtle createDate={props.thread.publishedDate}>
                <FormatComponent elementType={null} format={format}>
                    {getIdentityComponent(identity, "activity-card-first-image")}
                </FormatComponent>
            </ActivityCardSubtle>
        );
    }

    return (
        <ActivityCardSubtle createDate={props.thread.publishedDate}>
            <ActivityShimmer />
        </ActivityCardSubtle>
    );
};

Components.add("ms.vss-code-web.source-branch-changed-activity-card", SourceBranchStateCard);
